import { ArtifactsManager } from '@/components/artifacts/ArtifactsManager';
import { useTemplateContext } from '@/pages/templates/useTemplateContext';
import { Skeleton } from '@startupquickstart/frontend';

/**
 * Template Artifacts tab — thin wrapper around the shared owner-scoped
 * ArtifactsManager. Templates have no lifecycle, so structure is always
 * editable.
 */
export function TemplateArtifactsTab() {
  const { template, isLoading } = useTemplateContext();

  if (isLoading) {
    return (
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <Skeleton className="h-7 w-32" />
          <Skeleton className="h-9 w-36" />
        </div>
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} className="h-32 rounded-xl" />
        ))}
      </div>
    );
  }

  if (!template) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Template not found</p>
      </div>
    );
  }

  return (
    <ArtifactsManager
      ownerId={template.id}
      apiBase={`/templates/${template.id}`}
      keyPrefix="Template"
      structureEditable
    />
  );
}
